import { render, staticRenderFns } from "./GiveOrRedeem.vue?vue&type=template&id=49ade0fa&scoped=true&"
import script from "./GiveOrRedeem.vue?vue&type=script&lang=js&"
export * from "./GiveOrRedeem.vue?vue&type=script&lang=js&"
import style0 from "./GiveOrRedeem.vue?vue&type=style&index=0&id=49ade0fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ade0fa",
  null
  
)

export default component.exports